import React, { useState, useEffect } from 'react';
import { List, Datagrid, TextField, EmailField } from 'react-admin';


export const TransactionList = props => (
	<List {...props} bulkActionButtons={false} >
		<Datagrid rowClick="show">
			<TextField source="date" />
			<TextField source="from" />
			<TextField source="to" />
			<TextField source="value" />
			<TextField source="status" />
		</Datagrid>
	</List>
);